module.exports = __webpack_public_path__ + "static/media/datazip-footer-logo.7ff67e8a.svg";